import type { WaterStressEvidence } from '../../types/siteEvidence';

/** Resolve WRI's score bands before legacy category numbering; overallWaterRisk is a separate indicator. */
export function resolveWaterStressBand(water: Pick<WaterStressEvidence, 'bwsScore' | 'bwsCategory' | 'bwsLabel' | 'stressLevel'>): { category: number | null; label: string } {
  if (water.bwsCategory === -1 || /arid/i.test(water.bwsLabel)) return { category: -1, label: 'Arid and low water use' };
  const score = water.bwsScore;
  const label = water.bwsLabel?.replace(/^\d+\.\s*/, '').trim() ?? '';
  let category: number | null = null;
  if (score != null && Number.isFinite(score) && score >= 0 && score <= 5) category = Math.min(4, Math.floor(score));
  else if (/extremely high/i.test(label)) category = 4;
  else if (/medium.*high|20\s*[–-]\s*40/i.test(label)) category = 2;
  else if (/low.*medium|10\s*[–-]\s*20/i.test(label)) category = 1;
  else if (/\bhigh\b|40\s*[–-]\s*80/i.test(label)) category = 3;
  else if (/\blow\b|<\s*10/i.test(label)) category = 0;
  else if (water.bwsCategory != null && water.bwsCategory >= 0 && water.bwsCategory <= 4) category = water.bwsCategory;
  else if (water.stressLevel === 'High') category = 3;
  const labels = ['Low (<10%)', 'Low to medium (10–20%)', 'Medium to high (20–40%)', 'High (40–80%)', 'Extremely High (>80%)'];
  return { category, label: category == null ? label || water.stressLevel : labels[category]! };
}
